import styled from 'styled-components';
import Button from '@womcorp/wom-miwom-ui-kit/dist/components/Button';
import {
  InfoIcon,
  WarningIcon,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';

const ContentStyled = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 24px 8px;
`;

const ErrorContentStyled = styled(ContentStyled)`
  max-width: 280px;
`;

const TitleStyled = styled.h2`
  color: #0e141d;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  margin-bottom: 6px;
  text-align: center;

  ${ErrorContentStyled} & {
    color: #494c66;
  }
`;

const BodyStyled = styled.div`
  color: #494c66;
  font-size: 16px;
  line-height: 20px;
  padding: 24px 0;
  text-align: center;
`;

const NoticeStyled = styled.div`
  color: #494c66;
  display: flex;
  font-size: 14px;
  line-height: 18px;
  margin-top: 72px;
`;

const NoticeIconStyled = styled(InfoIcon)`
  flex-shrink: 0;
  margin: 2px 8px 0 2px;
  path {
    fill: #4d008c;
  }
`;

const ButtonStyled = styled(Button)`
  ${ErrorContentStyled} & {
    max-width: 180px;
  }
`;

const CancelButtonStyled = styled(Button)`
  ${ContentStyled} & {
    border-bottom: 1px solid #4d008c;
    border-radius: 0;
    color: #4d008c;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin: 16px 0 0;
    padding: 0;
    text-transform: none;
    width: auto;

    :hover {
      background: none;
    }
  }
`;

const WarningMessageStyled = styled.div`
  background: #fff7dd;
  border: 1px solid #ffc71e;
  border-radius: 8px;
  display: flex;
  margin-bottom: 24px;
  padding: 16px;

  p {
    color: #0e141d;
    font-size: 12px;
    line-height: 16px;
  }

  a {
    color: #4d008c;
  }
`;

const DangerIconStyled = styled(WarningIcon)`
  flex-shrink: 0;
  margin-right: 8px;
`;

const ServiceErrorStyled = styled.div`
  align-items: center;
  background-color: #e2e6ea;
  border-radius: 50%;
  display: flex;
  height: 88px;
  justify-content: center;
  width: 88px;
`;

export {
  ContentStyled,
  ErrorContentStyled,
  TitleStyled,
  BodyStyled,
  NoticeStyled,
  NoticeIconStyled,
  ButtonStyled,
  CancelButtonStyled,
  WarningMessageStyled,
  DangerIconStyled,
  ServiceErrorStyled,
};
